// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6fe2aa1f","453":"d1994899","455":"9b90361b","977":"7919951a"}[chunkId] + ".chunk.js";
};